export const FLEET_SWITCHING_TERMS_AND_CONDITIONS =
  'FLEET_SWITCHING_TERMS_AND_CONDITIONS';
export const FLEET_SWITCHING_TERMS_AND_CONDITIONS_REQUEST =
  'FLEET_SWITCHING_TERMS_AND_CONDITIONS_REQUEST';
export const FLEET_SWITCHING_TERMS_AND_CONDITIONS_SUCCESS =
  'FLEET_SWITCHING_TERMS_AND_CONDITIONS_SUCCESS';
export const FLEET_SWITCHING_TERMS_AND_CONDITIONS_FAILURE =
  'FLEET_SWITCHING_TERMS_AND_CONDITIONS_FAILURE';
